import moment from 'moment';
import React from 'react';
import {LAST6MONTHS, LASTYEAR} from '../../constants/constants';
import DropdownSelect from '../shared/dropdown-select/dropdown-select';

const options = [
  { label: 'Show All', value: ''},
  { label: 'Newest', value: LAST6MONTHS},
  { label: 'Last Year', value: LASTYEAR},
];

const ResultsHeader = ({changeFilter, resultState}) => {
  const handleSelect = (option, id) => {
    changeFilter(id, option.value);
  };
  const getYears = (yearsToShow) => {
    var years = [];
    for (let x = 1; x < yearsToShow; x++) {
      years.push({ label: moment().subtract(x, 'years').year(), value: moment().subtract(x, 'years').year().toString() });
    }
    return years;
  }

  return (
    <div id="human-readable-filter" className="for-light col-xs-16 flush-left">
      <div className="header-dropdowns">
        <DropdownSelect
          label="Filter By"
          id="byDate"
          options={options.concat(getYears(10))}
          handleChange={handleSelect}
          selected={resultState.filter.byDate}
        />
      </div>
    </div>
  );
};

export default ResultsHeader;



// WEBPACK FOOTER //
// ./src/components/press/results-header.js